import Vue from 'vue';
import OshCalculator from './osh-calculator/osh-calculator.vue';
Vue.component('osh-calculator', OshCalculator);
